import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import locales from '@/locale/index.js'
import bridge from './utils/jsbridge'
import { getWorldActivityInfo, getModelActivityInfo } from './api';


import App from './App';





const localeMap = new Map([
  // ios
  ["EN", "en"],
  ["TH", "th"],
  ["VN", "vi"],
  ["ID", "in"],
  ["TW", "zh"],
  ["JP", "jp"],
  ["AE", "ar"], // 埃及
  ["AR", "es"], // 西班牙
  ["BR", "pt"],
  ["TR", "tr"],
  ["RU", "ru"],
  //	android
  ["en", "en"],
  ["th", "th"],
  ["vi", "vi"],
  ["in", "in"],
  ["ja", "jp"],
  ["zh", "zh"],
  ["ms", ""], // malay
  ["es", "es"],
  ["pt", "pt"],
  ["tr", "tr"],
  ["ru", "ru"],
  ["ar", "ar"],
]);

const langMap = new Map([
  ["ID", "in"],
  ["PH", "en"],
  ["BR", "pt"]
])

function IntlApp() {
  const [lang, setLang] = useState()

  useEffect(() => {
    const initialize = async () => {
      let {lang: loc} = await bridge.getQueryParam() || {lang: 'en'};
      console.log(loc, 'loc')
      loc = localeMap.get(loc)

      if (Object.keys(locales).indexOf(loc) < 0) {
        loc = "en";
      }
      setLang(loc)
    }
    initialize();
  }, []);

  


  return (
    <IntlProvider
      locale={lang}
      messages={locales[lang]}
    >
      <App />
    </IntlProvider>
  );
}
export default IntlApp;